import {
  EarningRuleGlobalLimitReward,
  POINT_RECORD_TYPE,
  SESSION_KEYS,
} from 'config/CustomEnums';
import { loading } from 'models/LoadingUtil';
import { defaultStep, getNewStepConfig } from 'models/StepBarUtil';
import {
  createPointAddTypeRecord,
  createPointRemoveTypeRecord,
} from 'services/TransactionRecordsAPIHelper';
import {
  adjustValidation,
  parseAdjustValidationResultList,
  parseAdjustValidationTitle,
} from 'services/TransactionRecordsAPIHelper';

import {
  getObjectFromSessionStorage,
  removeFromSessionStorage,
  saveToSessionStorage,
} from 'utils';

export const sessionDataKey = {
  stepEndKey: SESSION_KEYS.CREATE_POINT_RECORD_STEP_END_SESSION_KEY,
  origionalData: SESSION_KEYS.CREATE_POINT_RECORD_ORIGINAL_DATA_SESSION_KEY,
};

export const CreatePointRecordError = {
  selectCustomer: {
    message: 'Please provide a customer.',
  },
  operatedPoints: {
    message: 'Please provide a value.',
  },
  operatedPointsTpe: {
    message: "Must fill in either 'Points' or 'Progression points'.",
  },
};

function pointRecordInit() {
  return {
    pointType: null,
    customer: {},
    points: null,
    remarks: null,
  };
}

function getInitState() {
  const stepNameList = ['Type', 'Properties'];
  return {
    pointRecord: pointRecordInit(),
    stepConfig: defaultStep(stepNameList),
    currentStep: 0,
    pointRecordCreated: false,
    hasUpdatedDefaultValues: false,
    adjustPointValidationResult: null,
    adjustTpeValidationResult: null,
  };
}

export function parsePointRecordInputBody(pointRecord) {
  return {
    customer: pointRecord.customer.pk,
    points: pointRecord.points || null,
    tpe: !!pointRecord.tpe ? pointRecord.tpe : null,
    transactionId: pointRecord.transaction?.value?.pk,
    remarks: pointRecord.remarks,
  };
}

export default {
  namespace: 'createPointRecord',
  state: getInitState(),

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    loadRecordFromCookie(state, { payload }) {
      const record = getObjectFromSessionStorage(sessionDataKey.origionalData);
      if (!record) {
        return {
          ...state,
        };
      }
      saveToSessionStorage(sessionDataKey.origionalData, record);
      return {
        ...state,
        pointRecord: record,
        hasUpdatedDefaultValues: true,
      };
    },
    saveOrRemoveRecordFromCookie(state, { payload }) {
      if (payload.save) {
        if (payload.values) {
          saveToSessionStorage(sessionDataKey.origionalData, payload.values);
        }
      } else {
        removeFromSessionStorage(sessionDataKey.origionalData);
      }
      saveToSessionStorage(sessionDataKey.stepEndKey, true);
      return {
        ...state,
      };
    },
    stepChange(state, { payload }) {
      const isBack = payload.isBack;
      let step = payload.step;
      const isValid = payload.isValid;
      const stepConfig = getNewStepConfig(
        step,
        state.stepConfig,
        !isValid,
        isBack,
      );
      if (isValid) {
        step = isBack ? step - 1 : step + 1;
      }
      return {
        ...state,
        stepConfig,
        currentStep: step,
      };
    },
    clearData(state, { payload }) {
      return { ...state, ...getInitState() };
    },
  },

  effects: {
    adjustPointValidation: [
      function* ({ payload }, { call, select, put }) {
        yield put({
          type: 'updateState',
          payload: {
            adjustPointValidationResult: null,
            adjustTpeValidationResult: null,
          },
        });
        const {
          customerId,
          points,
          tpe,
          validationFailure = () => {},
          validationSuccess = () => {},
        } = payload;

        let isFailed = false;
        if (Number(points) > 0) {
          const pointResponse = yield call(
            adjustValidation,
            customerId,
            EarningRuleGlobalLimitReward.POINTS,
            points,
          );
          console.log('pointResponse', pointResponse);
          if (pointResponse?.status === 200) {
            const unit = 'points';
            const adjustPointValidation = parseAdjustValidationResultList(
              pointResponse?.data?.data,
              unit,
            );
            console.log('adjustPointValidation', adjustPointValidation);
            if (adjustPointValidation?.length > 0) {
              yield put({
                type: 'updateState',
                payload: {
                  adjustPointValidationResult: {
                    title: parseAdjustValidationTitle(points, unit),
                    results: adjustPointValidation,
                  },
                },
              });
              isFailed = true;
            }
          }
        }

        if (Number(tpe) > 0) {
          const tpeResponse = yield call(
            adjustValidation,
            customerId,
            EarningRuleGlobalLimitReward.PROGRESSION_POINTS,
            tpe,
          );
          console.log('tpeResponse', tpeResponse);
          if (tpeResponse?.status === 200) {
            const unit = 'progression points';
            const adjustTpeValidation = parseAdjustValidationResultList(
              tpeResponse?.data?.data,
              unit,
            );
            if (adjustTpeValidation?.length > 0) {
              yield put({
                type: 'updateState',
                payload: {
                  adjustTpeValidationResult: {
                    title: parseAdjustValidationTitle(tpe, unit),
                    results: adjustTpeValidation,
                  },
                },
              });
              isFailed = true;
            }
          }
        }

        if (isFailed) {
          yield validationFailure();
        } else {
          yield validationSuccess();
        }
      },
      { type: 'takeLatest' },
    ],
    adjustPoint: [
      function* ({ payload }, { select, put }) {
        const { values } = payload;
        const inputBody = parsePointRecordInputBody(values);
        let serviceArgs =
          values.pointType === POINT_RECORD_TYPE.TYPE_ADD
            ? [createPointAddTypeRecord, inputBody]
            : [createPointRemoveTypeRecord, inputBody];
        saveToSessionStorage(sessionDataKey.stepEndKey, true);
        function* onSuccess() {
          removeFromSessionStorage(sessionDataKey.origionalData);
          yield put({
            type: 'updateState',
            payload: {
              pointRecordCreated: true,
              formHasSubmitted: true,
            },
          });
        }
        function* onFailed(data) {
          console.log('@@208: ', data);
          yield put({
            type: 'updateState',
            payload: {
              formHasSubmitted: true,
            },
          });
        }
        yield loading(serviceArgs, onSuccess, onFailed);
      },
      { type: 'takeLatest' },
    ],
  },
};
